const { isServer } = require('./is-server')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @returns {boolean}
 */
function likelyLoggedIn () {
  return !isServer() && !!document.cookie?.includes('access_scope')
}

module.exports = { likelyLoggedIn }
